import { render, staticRenderFns } from "./Reason.vue?vue&type=template&id=7b4224e1&scoped=true"
import script from "./Reason.vue?vue&type=script&lang=js"
export * from "./Reason.vue?vue&type=script&lang=js"
import style0 from "./Reason.vue?vue&type=style&index=0&id=7b4224e1&prod&scoped=scoped&lang=css"
import style1 from "./Reason.vue?vue&type=style&index=1&id=7b4224e1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b4224e1",
  null
  
)

export default component.exports